import React from 'react';
import './TopGlobeRotating.css'; 

const TopGlobeRotating = () => {
  return (
    <div className='topGlobeRotating'>
      <img src='https://upload.wikimedia.org/wikipedia/commons/7/7f/Rotating_earth_animated_transparent.gif' alt='globe' />
    </div>
  );
}

export default TopGlobeRotating;
